import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { signoutRedirect } from "../../services/userService";
import "bootstrap/dist/css/bootstrap.min.css";

const getMonogramColor = (name) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = Math.abs(hash) % 360;
    return `hsl(${h}, 55%, 35%)`;
};

const Header = () => {
    const { t, i18n } = useTranslation();
    const user = useSelector((state) => state.auth.user);

    const profile = process.env.REACT_APP_PROFILE || "aenduo";
    const profileUrl = process.env.REACT_APP_PROFILE_URL || "#";
    const publicUrl = process.env.PUBLIC_URL || "";

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    const givenName = user.profile.given_name || "";
    const familyName = user.profile.family_name || "";
    const userInitials = `${givenName.charAt(0)}${familyName.charAt(0)}`.toUpperCase();
    const fullName = `${givenName} ${familyName}`.trim();
    const monogramColor = useMemo(() => getMonogramColor(fullName || "U"), [fullName]);

    return (
        <header className="d-flex justify-content-between align-items-center px-4 py-2 border-bottom">
            <div className="d-flex align-items-center">
                <img
                    src={`${publicUrl}/assets/${profile === "philips" ? "PhilipsLogo.png" : "aenduo_logo.svg"}`}
                    alt="Logo"
                    style={{ height: "60px" }}
                />
                <span className="ms-3 fs-3 fw-light">{t("header.portal")}</span>
            </div>
            <div className="d-flex align-items-center text-nowrap text-primary">
                <span className="fs-5">{fullName}</span>
                <div
                    className="ms-3 d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                    style={{
                        width: "42px",
                        height: "42px",
                        backgroundColor: monogramColor,
                        color: "#fff",
                        fontSize: "0.95rem",
                        fontWeight: 600,
                        letterSpacing: "0.5px",
                    }}
                >
                    {userInitials}
                </div>
                <div className="dropdown ms-2">
                    <button
                        className="btn btn-outline-primary dropdown-toggle no-text-button"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    ></button>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                        <li>
                            <button className="dropdown-item" onClick={() => changeLanguage("en")}>
                                <img src={`${publicUrl}/assets/flags/eng.png`} alt="English Flag" style={{ width: "20px", marginRight: "5px", border: "1px solid #ffffff" }} />
                                EN
                            </button>
                        </li>
                        <li>
                            <button className="dropdown-item" onClick={() => changeLanguage("pl")}>
                                <img src={`${publicUrl}/assets/flags/pl.png`} alt="Polish Flag" style={{ width: "20px", marginRight: "5px", border: "1px solid #e1e1e1" }} />
                                PL
                            </button>
                        </li>
                        <li>
                            <hr className="dropdown-divider" />
                        </li>
                        <li>
                            <a target="_blank" rel="noopener noreferrer" className="dropdown-item" href={profileUrl}>
                                <FontAwesomeIcon icon={faUser} className="me-2" /> {t("header.profile")}
                            </a>
                        </li>
                        <li>
                            <button className="dropdown-item" onClick={() => signoutRedirect()}>
                                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> {t("header.logout")}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
};

export default Header;
